import { render, staticRenderFns } from "./MainPrintingLayout.vue?vue&type=template&id=63a1da85&"
import script from "./MainPrintingLayout.vue?vue&type=script&lang=ts&"
export * from "./MainPrintingLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
